import React from 'react';
import Header from '../components/Header';
import ContactComponent from '../components/Contact';
import Footer from '../components/Footer';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ContactComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Contact;